<script>
	export var id
	export var extraGeography
	export var positiveIncrease

	import {onMount} from 'svelte'
	import jenks from './helpers/jenks.js'
	import comma from './helpers/comma.js'
	import {colorsJenks, colorsChange, colorsChangeReverse} from './helpers/colors.js'
	import isNumeric from './helpers/isnumeric.js'
	import config from './config.js'

	import {showChange, data, ann, jenksBreaks, geo2data, geojsonPath, changeBreaks} from './stores.js'

	var map;
  var geojsonLayer;
  var nocolor = '#cccccc';

  // Returns color based on geography
	var getColor = function(geo) {
    if (!geo) return nocolor;

		var val = geo['after'];
		var colors = colorsJenks;
		var breaks = $jenksBreaks;

		if ($showChange) {
      val = geo['percentchange'];
			breaks = changeBreaks;
      colors = positiveIncrease ? colorsChange : colorsChangeReverse;
		}

		if (val === '-') {
			return nocolor;
		}

		if (val[val.length - 1] === '+') {
			return colors[4];
		}

		for (var i in breaks) {
			if (i > 0 && val <= breaks[i]) {
				return colors[i-1];
			}
		}

		return nocolor;
	}

  // Function to center map properly
	var resizeMap = function() {
		map.fitBounds(geojsonLayer.getBounds())
	}

  // Function to initialize map asynchronously
	var initMap = async function() {
		map = L.map(id, {
			center: [41.33, -72.65],
			zoom: 9,
			zoomControl: false,
			scrollWheelZoom: false,
			attributionControl: false,
		});
		map.keyboard.disable()
		map.doubleClickZoom.disable()
		map.dragging.disable()
	}

  // Function to reload geojson asynchronously
	var reloadGeojson = async function() {
		const res = await fetch($geojsonPath);
		const json = await res.json();

		if (geojsonLayer) {
			map.removeLayer(geojsonLayer);
		}

		geojsonLayer = L.geoJson(json, {
			onEachFeature: function(f, l) {
				l.on({
					mouseover: function(e) {
						ann.update(x => e.target.feature.properties[config.geojsonGeographyProperty])
					},
					mouseout: function(e) {
						ann.update(x => '')
					}
				})
			},
		}).addTo(map);

		resizeMap();

		geo2data.subscribe(g2d => {

      showChange.subscribe(val => {
        geojsonLayer.eachLayer(layer => {
          var name = layer.feature.properties[config.geojsonGeographyProperty];
          layer.setStyle({
            fillColor: getColor(g2d[name]),
            fillOpacity: 1,
            color: 'white',
            weight: 1
          })
        })
      })

    })
    
	}

	$: if ($geojsonPath && map) {
		reloadGeojson();
	}

	onMount(initMap);

	window.addEventListener('resize', resizeMap)

</script>


<style>
	:global(.leaflet-container) {
		background-color: rgba(0,0,0,0) !important;
	}

	:global(.leaflet-interactive:hover) {
		fill-opacity: 0.5;
		color: green;
	}
</style>


<div id="{id}" class="w-100 h-100"></div>
